import { EmplacementApi, LocationEmplacementApi, EmplacementRead } from '@/api';
import { State } from '@/store/index';
import axios from 'axios';
import { Module } from 'vuex';

function getEmplacementApi(): EmplacementApi {
  return new EmplacementApi(undefined, import.meta.env.VITE_PROXY_URL, axios);
}

function getLocationEmplacementApi(): LocationEmplacementApi {
  return new LocationEmplacementApi(
    undefined,
    import.meta.env.VITE_PROXY_URL,
    axios,
  );
}

const getDefaultState = () => ({
  emplacements: [] as EmplacementRead[],
  lastLocation: undefined as number | undefined,
});

export type emplacementsState = ReturnType<typeof getDefaultState>;

export const Emplacements: Module<emplacementsState, State> = {
  namespaced: true,

  state: getDefaultState(),

  mutations: {
    setEmplacements(state, emplacements: EmplacementRead[]) {
      state.emplacements = emplacements;
    },
    setLastLocation(state, location?: number) {
      state.lastLocation = location;
    },
  },

  actions: {
    async fetchEmplacements({ commit, state }, locationId: number) {
      if (state.lastLocation === locationId) {
        return;
      }

      commit('setLastLocation', locationId);

      const api = getLocationEmplacementApi();
      const response = await api.locationEmplacementsGetCollection({
        location: locationId.toString(10),
      });

      const emplacements = response.data['hydra:member'].map(
        (locationEmplacement) => locationEmplacement.emplacement!,
      );

      if (emplacements.length > 0) {
        commit('setEmplacements', emplacements);
        return;
      }

      const fallbackApi = getEmplacementApi();
      const fallbackResponse = await fallbackApi.emplacementsGetCollection();
      commit('setEmplacements', fallbackResponse.data['hydra:member']);
    },
  },
};
